var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7515 9.80781C28.3285 4.05212 22.6365 0.0107422 15.9997 0.0107422C11.5813 0.0107422 7.58177 1.80193 4.68652 4.69755L8.6934 9.80781H30.7515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73884 22.1558L4.68652 27.3239C7.58177 30.2196 11.5813 32.0108 15.9997 32.0108C22.6588 32.0108 28.3671 27.9424 30.7762 22.1558H8.73884Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 11.7788V20.1846H31.4491C31.808 18.8539 32.0003 17.4549 32.0003 16.0107C32.0003 14.5456 31.8029 13.1268 31.434 11.7788H3.47852Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.69702C-1.56215 10.9454 -1.56215 21.0761 4.68622 27.3245C7.26828 24.7425 9.75159 22.2591 16 16.0108L4.68622 4.69702Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2112 12.0327L7.16402 14.7578L10.3595 13.7425L8.37133 16.442L10.3241 19.1672L7.14239 18.1105L5.15414 20.81L5.17602 17.4573L1.99414 16.4005L5.18939 15.3853L5.2112 12.0327Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSouthSudan);
export default __webpack_public_path__ + "static/media/flag_south_sudan.358f41cab30f07fe4614d6f1aec0c023.svg";
export { ForwardRef as ReactComponent };